import React from 'react';

interface Props {
    className?: string;
}

export const PlatformMessaging: React.FC<Props> = ({ className }) => {
    return (
        <svg className={`icon${className ? ` ${className}` : ''}`} width="110" height="65" viewBox="0 0 110 65">
            <g id="plat-message" transform={'translate(-524 -1308)'}>
                <g id="Path_92" data-name="Path 92" className="cls-1" transform="translate(524 1308)">
                    <path
                        className="cls-4"
                        d="M8,0h94a8,8,0,0,1,8,8V57a8,8,0,0,1-8,8H8a8,8,0,0,1-8-8V8A8,8,0,0,1,8,0Z"
                    />
                    <path
                        className="cls-5"
                        d="M 8 4 C 5.794403076171875 4 4 5.794399261474609 4 8 L 4 57 C 4 59.20560073852539 5.794403076171875 61 8 61 L 102 61 C 104.2055969238281 61 106 59.20560073852539 106 57 L 106 8 C 106 5.794399261474609 104.2055969238281 4 102 4 L 8 4 M 8 0 L 102 0 C 106.4182739257812 0 110 3.58172607421875 110 8 L 110 57 C 110 61.41827392578125 106.4182739257812 65 102 65 L 8 65 C 3.581710815429688 65 0 61.41827392578125 0 57 L 0 8 C 0 3.58172607421875 3.581710815429688 0 8 0 Z"
                    />
                </g>
                <g id="Group_17" data-name="Group 17" transform="translate(6.078 -6.795)">
                    <line
                        id="Line_1"
                        data-name="Line 1"
                        className="cls-2"
                        x2="29.829"
                        transform="translate(582.5 1330.5)"
                    />
                    <line
                        id="Line_2"
                        data-name="Line 2"
                        className="cls-2"
                        x2="29.829"
                        transform="translate(582.5 1338.897)"
                    />
                    <line
                        id="Line_3"
                        data-name="Line 3"
                        className="cls-2"
                        x2="29.829"
                        transform="translate(582.5 1347.295)"
                    />
                </g>
                <g id="Group_220" data-name="Group 220" transform="translate(-40.922 10)">
                    <line
                        id="Line_1-2"
                        data-name="Line 1"
                        className="cls-3"
                        x2="29.829"
                        transform="translate(582.5 1330.5)"
                    />
                    <line
                        id="Line_2-2"
                        data-name="Line 2"
                        className="cls-3"
                        x2="29.829"
                        transform="translate(582.5 1338.897)"
                    />
                    <line
                        id="Line_3-2"
                        data-name="Line 3"
                        className="cls-3"
                        x2="29.829"
                        transform="translate(582.5 1347.295)"
                    />
                </g>
            </g>
        </svg>
    );
};
